import PenerimaanPettyCashApi from '../__PenerimaanPettyCashApi__';

export const generateNoPettyCash = async (date) => {
  return await PenerimaanPettyCashApi.generateNumber({ tanggal: date }).then(
    (res) => res.data.data
  );
};
